var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHokPartnerAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b1b1b1;}.b{fill:#e30613;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -301)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 80,
    height: 80,
    rx: 40,
    transform: "translate(20 301)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.139 316.829)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.86,28.275a1.865,1.865,0,0,0,1.905-.238,2.411,2.411,0,0,0,.953-1.667V22.083h1.667V26.37a2.085,2.085,0,0,0,1.905,2.144h.476a12.367,12.367,0,0,0,0-23.818,1.865,1.865,0,0,0-1.905.238A2.411,2.411,0,0,0,23.909,6.6V10.65H22.242V6.363A1.8,1.8,0,0,0,21.289,4.7a2.092,2.092,0,0,0-1.667-.238A12.178,12.178,0,0,0,11.285,19.7a12.429,12.429,0,0,0,8.574,8.574ZM19.145,8.268V11.6a2.25,2.25,0,0,0,2.382,2.382h3.811A2.25,2.25,0,0,0,27.72,11.6V8.268a8.886,8.886,0,0,1,3.811,12.147,8.429,8.429,0,0,1-3.811,3.811V20.892a2.25,2.25,0,0,0-2.382-2.382H21.527a2.25,2.25,0,0,0-2.382,2.382v3.335a8.886,8.886,0,0,1-3.811-12.147,8.429,8.429,0,0,1,3.811-3.811Z",
    transform: "translate(-4.378 -4.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.467,20.4A1.628,1.628,0,0,0,19.8,22.067h0v5.24a1.526,1.526,0,0,0,1.905,1.429,1.537,1.537,0,0,0,1.429-1.429v-5.24A1.628,1.628,0,0,0,21.467,20.4Z",
    transform: "translate(8.067 17.807)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.867,20.4A1.628,1.628,0,0,0,11.2,22.067h0v5.24a1.526,1.526,0,0,0,1.905,1.429,1.537,1.537,0,0,0,1.429-1.429v-5.24A1.628,1.628,0,0,0,12.867,20.4Z",
    transform: "translate(-3.816 17.807)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.3,15.3H19.771A12.055,12.055,0,0,0,8.1,27.209v7.145a1.526,1.526,0,0,0,1.905,1.429,1.537,1.537,0,0,0,1.429-1.429V27.209a8.34,8.34,0,0,1,8.336-8.574H34.3a8.488,8.488,0,0,1,8.336,8.574v7.145a1.684,1.684,0,0,0,3.335.476V27.209A11.743,11.743,0,0,0,34.3,15.3Z",
    transform: "translate(-8.1 10.76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHokPartnerAvatar);
export default __webpack_public_path__ + "static/media/hok-partner-avatar.838cfb576199b0faff0df2987339bb76.svg";
export { ForwardRef as ReactComponent };